import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { get, isEmpty } from 'lodash';
import { ScreeningNeedSelector, ServiceProviders } from '@unite-us/screening';
import { BaseCard, BaseCardBody } from '@unite-us/ui';
import { browserHistory } from 'common/utils/browserHistory';
import featureFlag from 'common/utils/FeatureFlag/FeatureFlag';
import { showRiskDisplayOption } from '../utils';
import { RISK_LEVELS } from '../../constants';

class RiskDisplay extends Component {
  constructor(props) {
    super(props);
    this.onCreateReferrals = this.onCreateReferrals.bind(this);
  }

  onCreateReferrals(selectedNeeds = []) {
    const { screening } = this.props;

    const needIds = selectedNeeds.map((need) => need.service_type.id);
    const path = `/referrals/create/add-resources?person=${screening.contact.id}&form_submission=${screening.id}&services=${needIds}`; // eslint-disable-line max-len

    browserHistory.push(path);
  }

  render() {
    const { screening, isCaseManager } = this.props;

    if (isEmpty(screening)) {
      return null;
    }

    const { needs = [] } = screening;
    if (isEmpty(needs)) {
      return (
        <div className="risk-display">
          <BaseCard className="risk-display__no-needs">
            <BaseCardBody withPadding>
              <h3>No needs were identified for your client.</h3>
            </BaseCardBody>
          </BaseCard>
        </div>
      );
    }

    // Determine display based on risk levels.
    const riskLevel = get(screening, 'risk_level');
    const showProvidersList = showRiskDisplayOption(
      get(screening, 'configuration.resource_listing_option', {}),
      riskLevel,
    );

    // Choose component based on the flag.
    const needsDisplay = (
      <ScreeningNeedSelector
        initiallyChecked
        needs={needs}
        onSubmit={this.onCreateReferrals}
        isHighRisk={riskLevel === RISK_LEVELS.highRisk}
        isSupersetEnabled
      />
    );

    return (
      <div className="risk-display">
        { !isCaseManager && needsDisplay }
        {showProvidersList && <ServiceProviders needs={needs} />}
      </div>
    );
  }
}

RiskDisplay.propTypes = {
  screening: PropTypes.shape({
    contact: PropTypes.object,
    id: PropTypes.string,
    needs: PropTypes.array,
    risk_level: PropTypes.string,
  }),
  isCaseManager: PropTypes.bool.isRequired,
};

RiskDisplay.defaultProps = {
  screening: {},
};

export default featureFlag(RiskDisplay);
